import React from "react";
import { AppBar, Toolbar, Button, Box, Tooltip, IconButton } from "@mui/material";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useAuth } from "../context/AuthContext";
import HomeIcon from "@mui/icons-material/Home";

const Navbar = ({ onAddProduct, onFoundProducts, onNotFoundProducts }) => {
  const { user, isAdmin, loginType, setPosToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = async () => {
    if (loginType === 'guts') {
      await signOut(auth);
    } else {
      setPosToken(null);
    }
    navigate("/login");
  };

  const isAdminRoute = location.pathname.startsWith("/admin");
  const handleHomeClick = () => navigate("/search");

  // Regular navigation items for non-admin routes
  const navItems = [
    { to: "/search", label: "Search Image" },
    ...(isAdmin
      ? [{ to: "/admin", label: "Dashboard", tooltip: "add products" }]
      : []),
  ];

  return (
    <AppBar position="static">
      <Toolbar>
        {/* Home Icon - shown in admin routes */}
        {isAdminRoute && (
          <IconButton
            edge="start"
            color="inherit"
            aria-label="home"
            onClick={handleHomeClick}
          >
            <HomeIcon />
          </IconButton>
        )}

        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          {isAdminRoute ? (
            // Admin route buttons
            <>
              <Tooltip title="add a new product" placement="bottom">
                <Button color="inherit" onClick={onAddProduct}>
                  Add
                </Button>
              </Tooltip>
              <Tooltip title="view found products" placement="bottom">
                <Button color="inherit" onClick={onFoundProducts}>
                  Found
                </Button>
              </Tooltip>
              <Tooltip title="view not found products" placement="bottom">
                <Button color="inherit" onClick={onNotFoundProducts}>
                  Not Found
                </Button>
              </Tooltip>
            </>
          ) : (
            // Regular navigation items
            navItems.map((item) => (
              <Tooltip key={item.to} title={item.tooltip || ""} placement="top">
                <Button
                  color="inherit"
                  component={NavLink}
                  to={item.to}
                  sx={{ mx: 1 }}
                >
                  {item.label}
                </Button>
              </Tooltip>
            ))
          )}
        </Box>
        {user && (
          <Button color="inherit" onClick={handleLogout}>
            Logout
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
